import * as React from "react";

export const SvgJOSAircraft = (props) => (
	<svg width={37} height={37} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x={0.5} y={0.5} width={36} height={36} rx={8} fill="#FFF8EA" />
		<path
			d="m22.764 28.076-4.264-1.55-4.263 1.55a.4.4 0 0 1-.537-.376v-1.157c0-.416.212-.797.564-1.017l2.636-1.648v-5.187l-7.45 2.98a.401.401 0 0 1-.55-.371v-.767a2 2 0 0 1 .853-1.638l7.147-5.003V10.5c0-.882.718-1.6 1.6-1.6.883 0 1.6.718 1.6 1.6v3.392l7.147 5.002c.535.375.853.988.853 1.64v.766a.4.4 0 0 1-.549.371l-7.45-2.98v5.187l2.635 1.648c.353.221.564.601.564 1.017V27.7c0 .13-.064.253-.17.328a.402.402 0 0 1-.366.048Z"
			fill="#FFB11A"
		/>
	</svg>
);
